/**
 * Create Client Page — with password field
 */

import { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../services/firebase';
import { PortalHeader } from '../Layout/PortalHeader';

export function CreateClient() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [credits, setCredits] = useState(0);
  const [billingType, setBillingType] = useState<'per_call' | 'per_contact'>('per_call');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (password && password.length < 8) {
      setResult('Error: Password must be at least 8 characters');
      return;
    }
    setLoading(true);
    setResult(null);

    try {
      const createClientFn = httpsCallable(functions, 'createClient');
      const response = await createClientFn({ email, name, password: password || undefined, initialCredits: credits, billingType });
      const data = response.data as { message: string; clientId: string };
      setResult(`${data.message}. Client ID: ${data.clientId}`);
      setTimeout(() => navigate('/admin'), 3000);
    } catch (err) {
      setResult('Error: ' + (err instanceof Error ? err.message : 'Failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PortalHeader showCredits={false} />

      <div className="container" style={{ maxWidth: '600px' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Client Name *</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} required placeholder="Company or individual name" />
          </div>
          <div className="form-group">
            <label>Email Address *</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="client@example.com" />
          </div>
          <div className="form-group">
            <label>Password (min 8 chars, leave blank for auto-generated)</label>
            <input type="text" value={password} onChange={e => setPassword(e.target.value)} placeholder="Set client password" minLength={8} />
          </div>
          <div className="form-group">
            <label>Billing Type *</label>
            <select value={billingType} onChange={e => setBillingType(e.target.value as 'per_call' | 'per_contact')}>
              <option value="per_call">Per Call — $0.15/call (charged at send)</option>
              <option value="per_contact">Per Contact — $3.50/contact (charged for 30s+ prospect reached)</option>
            </select>
          </div>
          <div className="form-group">
            <label>Initial Credits ({billingType === 'per_contact' ? 'Contact' : 'Call'})</label>
            <input type="number" value={credits} onChange={e => setCredits(parseInt(e.target.value) || 0)} min="0" placeholder="0" />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating...' : 'Create Client'}
            </button>
            <Link to="/admin" className="btn btn-secondary">Cancel</Link>
          </div>
        </form>

        {result && (
          <div style={{
            marginTop: '24px', padding: '16px', borderRadius: '8px',
            background: result.startsWith('Error') ? 'var(--red-bg)' : 'var(--green-bg)',
            color: result.startsWith('Error') ? 'var(--red)' : 'var(--green)',
            border: `1px solid ${result.startsWith('Error') ? 'rgba(239,68,68,0.3)' : 'rgba(16,185,129,0.3)'}`
          }}>
            {result}
          </div>
        )}
      </div>
    </div>
  );
}
